
import Icon from "../components/icon/Icon"
import "./TranslationUploadFile.scss"
import Form from "../components/form/Form"

import switchPng from "./assets/images/switch-horizontal-01.svg"
import { useFormInstance } from "../components/form/FormContext"

import "./TranslationUploadFile.scss"
import { useEffect, useState } from "react"
import Button from "../components/Button"
import DocumentUpload from "./components/DocumentUpload"
import upload_fileApi from "../api/upload_file.api"
import Env from "../../Env"
import documentApi, { DocumentCreateRequest, DocumentDTO } from "../api/document.api"
import FormValidators from "../components/form/FormValidators"
import { useTranslate } from "../components/language"



const SelectOptionsTo = [
    {label: "English", value: "en"},
]

export default (props: {onCreate: (doc: DocumentDTO) => void}) => {

    const {t} = useTranslate()
    const formInstance = useFormInstance({autoValidate: false})
    const [support_languages, setSupportLanguages] = useState<{label: string, value: string}[]>([])
    const doSubmit = async (form: any) => {
        Env.DEBUG && console.log("doSubmit", form)
        let req: DocumentCreateRequest = {
            filename: form.file.name,
            object_key: form.file.file_id,
            size: form.file.size,
            mimetype: form.file.type,
            target_language: form.target_language,
        }
        const doc = await documentApi.create(req)
        props.onCreate(doc)

        return doc

    }

    const SelectOptionsFrom = [
        {label: t("Auto-detect"), value: "Auto-detect"},
    ]

    const get_support_languages = () => {
        if (support_languages.length > 0){
            return support_languages
        }
        return SelectOptionsTo.map(item => ({label: t(item.label), value: item.value}))
    }

    const btnNameRender = () =>{

        if(formInstance && !formInstance.disabled){
            return t("Start translation")
        }else{
            return t("Upload file")
        }
    }
    
    useEffect(() => {
        upload_fileApi.get_target_languages().then(data => {
            setSupportLanguages(data.map(item => ({label: t(item.label), value: item.value})))
            Env.DEBUG && console.log("support languages:", data)
            formInstance.setInitial({
            source_language: "Auto-detect",
            target_language: data[0].value,
        })
        })
    }, [])

    return (
        <div className="translation-uploadfile">
            <div className="header">
                <div className="title">{t("Upload and translate file")}</div>
                <div className="description">{t("Drop your file to start translating.")}</div>
                <div className="important">
                    <div className="important-title">{t("Important:")}</div>
                    <ul className="important-list">
                        <li>
                            {t("We support ")}
                            <strong>{t("PDF and image files only")}</strong>
                            {t(" (DOCX/DOC not accepted — please convert to PDF).")}
                        </li>
                        <li>
                            {t("Only the ")}
                            <strong>{t("first 15 pages")}</strong>
                            {t(" will be translated.")}
                        </li>
                        <li>
                            {t("For files over ")}
                            <strong>{t("10 MB")}</strong>
                            {t(" or longer than ")}
                            <strong>{t("15 pages")}</strong>
                            {t(", please ")}
                            <a href="mailto:info@roundblock.io" className="contact-link">
                                <strong>{t("contact us")}</strong>
                            </a>
                            {t(" for extended support.")}
                        </li>
                    </ul>
                </div>
            </div>
            <Form.Form instance={formInstance} showError={false} onSubmit={doSubmit}>
                <div className="form">
                    <div className="languages">
                        <div className="language">
                            <Form.Item name="source_language" label="" nowrap>
                                <Form.Select 
                                    placeholder={t("Source language: Auto-detect")}
                                    options={SelectOptionsFrom}
                                    ></Form.Select>
                            </Form.Item>
                        </div>
                        <Icon src={switchPng} size={20} padding={12}/>
                        <div className="language">
                            <Form.Item name="target_language" label="" nowrap >
                                <Form.Select placeholder="Target language: Select the target language" options={get_support_languages()}></Form.Select>
                            </Form.Item>
                        </div>
                    </div>
                    <Form.Item name="file" label="" nowrap required rules={[{validate:FormValidators.required, msg: ""}]}>
                        <DocumentUpload/>
                    </Form.Item>
                    <div className="b">
                        <div className="contactus">
                            {t("Working with something bigger?")}
                            <a className="link">{t("Contact us to get started.")}</a>
                        </div>
                        <Form.Submit style={{width:"185px"}}>{btnNameRender()}</Form.Submit>
                    </div>
                </div>
            </Form.Form>
        </div>
    )
}